@if (isEpcotBBMultisEnabled) {
    <div class="combo-bet-result-header__content">
        <div class="combo-bet-result-header__title">
            {{ headerTitle }}
            <div class="dot"></div>
            <div class="combo-bet-result-header__subtitle">{{ headerSubTitle }}</div>
        </div>
        <div class="combo-bet-result-header__odds">{{ formattedOdds(slip.totalOdds) }}</div>
    </div>
}
<bs-digital-result-succeeded-pick-list>
    @for (pick of slip.picks; track pick) {
        <bs-digital-result-succeeded-pick
            [pick]="pick"
            [boostedOdds]="isSingleBetPick ? slip.boostedOdds : undefined"
            [tokenPayoutSummary]="isSingleBetPick ? tokenPayoutSummary : undefined"
            [oddsDisplayFormat]="oddsDisplayFormat"
            [isSummaryVisible]="isSummaryVisible"
            [summary]="summaryViewModel" />
    }
</bs-digital-result-succeeded-pick-list>
